export default __webpack_public_path__ + "static/media/key-points.eb4eb26f.png";